import { useState, useEffect, useCallback } from "react";

const useToast = (timeoutDuration = 10000) => {
  const [toast, setToast] = useState({
    hidden: true,
    text: "",
    type: "",
    title: "",
  });

  useEffect(() => {
    let timeoutId;
    if (!toast.hidden) {
      timeoutId = setTimeout(() => {
        setToast((prev) => ({ ...prev, hidden: true }));
      }, timeoutDuration);
    }
    return () => clearTimeout(timeoutId);
  }, [toast, timeoutDuration]);

  const showToast = useCallback(({ text, type, title }) => {
    setToast({ hidden: false, text, type, title });
  }, []);

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, hidden: true }));
  }, []);

  return { toast, showToast, hideToast };
};

export default useToast;
